import * as reducers from "./reducers";
import { combineReducers } from "redux";

export const workflowList = combineReducers({ ...reducers });
